import React, { useEffect, useState } from 'react'
import userService from '../../services/userService'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import TableLoading from '../commonUIComponents/TableLoading'
import { useSnackbar } from 'notistack'

const UsersPage = () => {
  const [users, setUsers] = useState()
  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  useEffect(() => {
    setLoading(true)
    userService.getUsers()
      .then(res => setUsers(res))
      .catch(err => enqueueSnackbar(err.response?.data?.message, { variant: 'error' }))
      .finally(() => setLoading(false))
  }, [])
  return (
        <div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="100">#</TableCell>
                <TableCell width="40%">Username</TableCell>
                <TableCell>Nickname</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.map(user => (
                <TableRow key={user.id}>
                  <TableCell>{user.id}</TableCell>
                  <TableCell>{user.username}</TableCell>
                  <TableCell>{user.nickname}</TableCell>
                </TableRow>
              ))}
              <TableLoading loading={loading} colSpan={3}/>
            </TableBody>
          </Table>
        </div>
  )
}

export default UsersPage
